require('../scripts/jquery.validate.min');


$.validator.addMethod('password', function (value, element) {
    return this.optional(element) || window.validatePassword(value);
}, 'La password deve essere compresa tra 5 e 10 carattere e può contenere solo lettere non accentate e numeri');

$.validator.addMethod('fiscalCode', function (value, element) {
    if($('#country_code-privato').val() == 'IT'){
        return this.optional(element) || window.validateCF(value);
    }else{
        return this.optional(element) || window.validateCFnonIT(value);
    }
}, 'Codice fiscale errato');

$.validator.addMethod('phone', function (value, element) {
    return this.optional(element) || (/^\+?[0-9\s]+$/).test(value);
}, 'Inserisci un numero di telefono valido. Sono ammessi solo numeri e il carattere +');

$.validator.addMethod('alphanumeric', function (value, element) {
    return this.optional(element) || (/^[0-9A-Za-z]+$/).test(value);
}, 'Il campo può contenere solo lettere e numeri');

$.validator.addMethod('confirmation', function(value, element) {
    const id = $(element).attr('id').replace('_confirmation', '');
    const main = $(element).closest('form').find(`[name="${id}"]`)[0];

    if(!main.value) {
        return true;
    }

    return this.optional(element) || (main.value && element.value === main.value);

}, function(params, element){
    let confirmation = $(element).attr('id');
    let main = confirmation.replace('_confirmation', '');

    if (params) {
        if (params.confirmationLabel) {
            confirmation = params.confirmationLabel;
        }

        if (params.fieldLabel) {
            main = params.fieldLabel;
        }
    }

    return `I campi ${main} e ${confirmation} non coincidono`;
});



$(document).ready(function () {
    const customerType = $('#customer_type');
    const pecAzienda = $('#pec-azienda');
    const sdiAzienda = $('#sdi-azienda');
    const userTeam = $('#is-user-team');

    const aziendaFieldSet = $('fieldset#fieldset_cliente_azienda');
    const privatoFieldSet = $('fieldset#fieldset_cliente_privato');

    const codiceFiscaleAzienda = $('#fiscal_code-azienda');
    const partitaIva = $('#vat_number');

    $('form#form_registrazione').validate({
        errorElement: 'span',
        errorClass: 'errore error-feedback',
        /**
         * @param {HTMLFormElement} form
         * @param {jQuery.Event}    event
         */
        submitHandler: function(form, event) {
            let inputs;

            if (customerType.val() === 'azienda') {
                inputs = privatoFieldSet.find('input, select, textarea');
            } else {
                inputs = aziendaFieldSet.find('input, select, textarea');
            }

            inputs.attr('disabled', true);
            form.submit();
            inputs.attr('disabled', false);
        },
        rules: {
            'email': {
                required: true,
                email: true,
            },
            'email_confirmation': {
                confirmation: {
                    param: {
                        confirmationLabel: 'Conferma Email',
                        fieldLabel: 'Email'
                    }
                }
            },
            'password': {
                required: true,
                minlength: 5,
                maxlength: 10,
                password: true,
            },
            'password_confirmation': {
                confirmation: {
                    param: {
                        confirmationLabel: 'Conferma Password',
                        fieldLabel: 'Password'
                    }
                }
            },
            'pec': {
                email: true,
                required: function () {
                    return !sdiAzienda.val() && customerType.val() === 'azienda'
                }
            },
            'sdi': {
                required: function () {
                    return !pecAzienda.val() && customerType.val() === 'azienda'
                }
            },
            'data[fiscal_code]': {
                required: function() {
                    return customerType.val() === 'privato' || (customerType.val() === 'azienda' && !partitaIva.val());
                },
                fiscalCode: (customerType.val() === 'privato' && $("#company_team").length == 0),
            },
            'data[vat_number]': {
                alphanumeric: true,
                required: function() {
                    return !codiceFiscaleAzienda.val();
                }
            },
            'data[city]': {required: true},
            'data[zip]': {required: true, digits: true},
            'data[address]': {required: true},
            'data[phone]': {required: true, phone: true},
            'data[mobile]': {required: true, phone: true},
            'data[country_code]': {required: true},
            'data[province_code]': {required: true},
            'data[province_name]': {required: true},

            // PRIVATI
            'data[name]': {required: true},
            'data[surname]': {required: true},

            // AZIENDE
            'data[company]': {required: true},
            //PRIVACIES
            'privacy_porsche_marketing' : {required: true},
            'privacy_porsche_profilazione' : {required: true},
            'privacy_centri_porsche_marketing' : {required: true},
            'privacy_centri_porsche_profilazione' : {required: true},
            'privacy_gruppo_porsche_marketing' : {required: true}
        },
        groups: {
            privacies: 'privacy_porsche_marketing privacy_porsche_profilazione privacy_centri_porsche_marketing privacy_centri_porsche_profilazione privacy_gruppo_porsche_marketing'
        },
        errorPlacement: function(error, element) {

            if (element.attr("name").match('privacy_')) {
                $("#privacies_error").show();
            } else {
                error.insertAfter(element);
            }
        }
    });

    sdiAzienda.on('focusout', function() {
        pecAzienda.valid();
    });

    pecAzienda.on('focusout', function() {
        sdiAzienda.valid();
    });

    customerType.change(function() {
        if (this.value === 'azienda') {
            $('#fiscal_code-azienda').rules( "remove", "fiscalCode" );
            privatoFieldSet.hide();
            privatoFieldSet.attr('disabled', true);
            aziendaFieldSet.show();
            aziendaFieldSet.attr('disabled', false);
        } else {
            $('#fiscal_code-azienda').rules( "add", "fiscalCode" );
            aziendaFieldSet.hide();
            aziendaFieldSet.attr('disabled', true);
            privatoFieldSet.show();
            privatoFieldSet.attr('disabled', false);
        }
        triggerChangeCountryCode(this.value)
    });

    $('#fiscal_code-privato, #fiscal_code-azienda').keyup(function() {
        this.value = this.value.toUpperCase()
    })

    $('#country_code-privato, #country_code-azienda').change(function() {
        const type = $(this).attr('id').split('-')[1];
        const provinceCode = $(`#province_code-${type}`);
        const provinceCodeWrapper = provinceCode.closest('.form-column');

        const provinceName = $(`#province_name-${type}`);
        const provinceNameWrapper = provinceName.closest('.form-column');


        if (this.value === 'IT' || this.value === 'US') {
            provinceNameWrapper.hide();
            provinceName.val('');

            provinceCodeWrapper.show();
            provinceCode.val('');

            provinceCode.find(`option[data-country-code!="${this.value}"]`).hide();
            provinceCode.find(`option[data-country-code="${this.value}"]`).show();

        } else {
            provinceCodeWrapper.hide();
            provinceCode.val('');

            provinceNameWrapper.show();
            provinceName.val('');
        }

        $(`#country_name-${type}`).val($(this).find(`option[value="${this.value}"]`).text().trim());
    });

    $('#province_code-azienda, #province_code-privato').change(function() {
        const type = $(this).attr('id').split('-')[1];
        const provinceName = $(`#province_name-${type}`);
        const countryCode = $(`#country_code-${type}`);

        const text = $(this).find(`option[value="${this.value}"][data-country-code="${countryCode.val()}"]`).text();

        provinceName.val(text);
    });

    function triggerChangeCountryCode(customerTypeVal)
    {
        if (customerTypeVal === 'azienda') {
            $("#country_code-azienda").trigger("change");
        } else {
            $("#country_code-privato").trigger("change");
        }
    }

    triggerChangeCountryCode(customerType.value)

    customerType.trigger('change');
});
